const FNV_OFFSET_BASIS = 0x811c9dc5;
const FNV_PRIME = 0x01000193;
const ROLLOUT_BUCKET_COUNT = 100;
const UTF8 = new TextEncoder();

function fnv1a32(bytes: Uint8Array): number {
  let hash = FNV_OFFSET_BASIS;
  for (const byte of bytes) {
    hash = Math.imul(hash ^ byte, FNV_PRIME);
  }
  return hash >>> 0;
}

export function hashToBucket(key: string, bucketCount: number): number {
  return fnv1a32(UTF8.encode(key)) % bucketCount;
}

function rolloutBucket(flag: string, accountId: number): number {
  return hashToBucket(`${flag}:${accountId}`, ROLLOUT_BUCKET_COUNT);
}

export function isInsideRollout(flag: string, accountId: number, percent: number): boolean {
  return rolloutBucket(flag, accountId) < percent;
}
